import { useState, useCallback } from 'react';

export const useConfirmation = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [confirmationConfig, setConfirmationConfig] = useState({
        title: '',
        message: '',
        confirmText: '',
        cancelText: '',
        confirmButtonClass: 'btn-danger',
        onConfirm: () => {},
        onCancel: () => {}
    });

    const confirm = useCallback((config) => {
        return new Promise((resolve) => {
            setConfirmationConfig({
                ...config,
                onConfirm: () => {
                    setIsOpen(false);
                    resolve(true);
                },
                onCancel: () => {
                    setIsOpen(false);
                    resolve(false);
                }
            });
            setIsOpen(true);
        });
    }, []);

    const closeConfirmation = useCallback(() => {
        setIsOpen(false);
        if (confirmationConfig.onCancel) {
            confirmationConfig.onCancel();
        }
    }, [confirmationConfig]);

    return {
        isOpen,
        confirmationConfig,
        confirm,
        closeConfirmation
    };
};